import{ createContext, useContext, useState } from 'react';

const DetailContext = createContext();

export const DetailProvider = ({ children }) => {

    const [spaces, setSpaces] = useState([]);
    const [sectionSlots, setSectionSlots] = useState([]);


    //todo da controllare
    const [selectedSpaceId, setSelectedSpaceId] = useState(0);
    const [selectedSectionIndex, setSelectedSectionIndex] = useState(0);
    const [selectedCollapsibleSlot, setSelectedCollapsibleSlot] = useState(0);
    const [selectedMixedElement, setSelectedMixedElement] = useState(0);
    const [selectedSectionSlot, setSelectedSectionSlot] = useState(0)

    const [sectionContext, setSectionContent] = useState([]);       //The content of the sections



    return (
        <DetailContext.Provider value={{ 
            spaces, setSpaces,
            sectionSlots, setSectionSlots,
            selectedSpaceId, setSelectedSpaceId,
            selectedSectionIndex, setSelectedSectionIndex,
            selectedCollapsibleSlot, setSelectedCollapsibleSlot,
            selectedMixedElement, setSelectedMixedElement,
            selectedSectionSlot, setSelectedSectionSlot,

            sectionContext, setSectionContent
             }}>
            {children}
        </DetailContext.Provider>
    );
};

export const useProjectDetailContext = () => {
    const context = useContext(DetailContext);
    if (!context) {
        throw new Error("useProjectDetailContext must be used within a ProjectDetailProvider");
    }
    return context;
};
